import { useEffect, useState, Component } from "react";
import Lenis from "lenis";
import "./App.css";
import AnnouncementBar from "./components/AnnouncementBar";
import LegalPage from "./components/LegalPage";
import Hero from "./components/Hero";
import SocialProof from "./components/SocialProof";
import Marquee from "./components/Marquee";
import Categories from "./components/Categories";
import WhatYouGet from "./components/WhatYouGet";
import HowItWorks from "./components/HowItWorks";
import OfferCard from "./components/OfferCard";
import Testimonials from "./components/Testimonials";
import WhoFor from "./components/WhoFor";
import Faq from "./components/Faq";
import FinalCta from "./components/FinalCta";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import StickyBuyBar from "./components/StickyBuyBar";
import PurchaseToasts from "./components/PurchaseToasts";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(err) {
        console.error(err);
    }
    render() {
        if (this.state.hasError)
            return (
                <div className="p-10 text-center text-slate-600">
                    Something went wrong. Please refresh the page.
                </div>
            );
        return this.props.children;
    }
}

export default function App() {
    const [route, setRoute] = useState(window.location.hash);

    useEffect(() => {
        const onHash = () => {
            setRoute(window.location.hash);
            if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
            else window.scrollTo(0, 0);
            if (typeof window.fbq === "function")
                window.fbq("track", "PageView");
        };
        window.addEventListener("hashchange", onHash);
        return () => window.removeEventListener("hashchange", onHash);
    }, []);

    // Meta Purchase when a shopper comes back from the payment page
    useEffect(() => {
        if (
            typeof window.fbq === "function" &&
            document.referrer.includes("superprofile.bio")
        ) {
            window.fbq("track", "Purchase", {
                content_name: "12,000+ eBook Mega Bundle",
                value: 199,
                currency: "INR",
            });
        }
    }, []);

    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    const isHome = !route.startsWith("#/");

    return (
        <ErrorBoundary>
            <div className="min-h-screen overflow-x-clip bg-[#ecfdf5] text-slate-900 antialiased">
                {isHome ? (
                    <>
                        <div className="sticky top-0 z-40">
                            <AnnouncementBar />
                        </div>
                        <main>
                            <Hero />
                            <SocialProof />
                            <Marquee />
                            <Categories />
                            <WhatYouGet />
                            <HowItWorks />
                            <OfferCard />
                            <Testimonials />
                            <WhoFor />
                            <Faq />
                            <FinalCta />
                        </main>
                        <Footer />
                        {/* spacer so the mobile sticky bar never covers the footer */}
                        <div className="h-24 md:hidden" aria-hidden="true" />
                        <StickyBuyBar />
                        <PurchaseToasts />
                    </>
                ) : (
                    <LegalPage type={route} />
                )}
                <FloatingWhatsApp />
            </div>
        </ErrorBoundary>
    );
}
